// extracted by mini-css-extract-plugin
export default {"menuProducts":"MenuProducts_menuProducts__zeQTh","itemLink":"MenuProducts_itemLink__byGg+","openProducts":"MenuProducts_openProducts__lzGtC"};